import React, { useState, useEffect } from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import About from '../components/About';
import Services from '../components/Services';
import Portfolio from '../components/Portfolio';
import Testimonials from '../components/Testimonials';
import Contact from '../components/Contact';
import Footer from '../components/Footer';
import { mockData } from '../mockData';

const Home = () => {
  const [data, setData] = useState(mockData);

  return (
    <div className="home">
      <Header />
      <Hero data={data.hero} />
      <About data={data.about} />
      <Services data={data.services} />
      <Portfolio data={data.portfolio} />
      <Testimonials data={data.testimonials} />
      <Contact data={data.contact} />
      <Footer />
    </div>
  );
};

export default Home;
